module.exports = __webpack_public_path__ + "static/media/home-wellbeing-survey.f5912739.png";